// ─── 7 Domain Verticals Translation Dictionary (EN <-> FR) ───────────────────
// Covers:
// 1. Real Estate & Property Management (Immobilier & Gestion Locative)
// 2. Barbershop & Men's Grooming (Barbier & Coiffure Homme)
// 3. Spa, Massage & Wellness Sanctuary (Spa, Massage & Bien-Être)
// 4. Bespoke Tailoring & Haute Couture (Atelier Sur-Mesure & Couture)
// 5. Professional Services, Legal & Consulting (Cabinet de Conseil & Services Pro)
// 6. Hair Salon, Color Bar & Beauty Studio (Salon de Coiffure & Institut de Beauté)
// 7. Car Rental, Chauffeur & Fleet Operations (Location de Véhicules & Flotte)
// 8. All 31 Domain Roles, 29 Granular Feature Permissions & Sidebar Navigation

export const verticalsFallbacks: Record<string, Record<string, string>> = {
  fr: {
    // ── Common Vertical Actions & Filters ──
    'Refresh': 'Actualiser',
    'Cancel': 'Annuler',
    'Search': 'Rechercher',
    'Search records...': 'Rechercher dans la liste...',
    'Status': 'Statut',
    'Actions': 'Actions',
    'Completed': 'Terminé',
    'COMPLETED': 'TERMINÉ',
    'Active': 'Actif',
    'ACTIVE': 'ACTIF',
    'PAID': 'PAYÉ',
    'OCCUPIED': 'OCCUPÉ',
    'VACANT': 'VACANT',
    'AVAILABLE': 'DISPONIBLE',
    'IN_CHAIR': 'AU FAUTEUIL',
    'IN_SESSION': 'EN SÉANCE',
    'WAITING': 'EN ATTENTE',
    'CONFIRMED': 'CONFIRMÉ',
    'RENTED': 'LOUÉ',
    'MAINTENANCE': 'MAINTENANCE',
    'INVOICED': 'FACTURÉ',
    'LOGGED': 'ENREGISTRÉ',
    'OPEN': 'OUVERT',
    'RESOLVED': 'RÉSOLU',

    // ── Sidebar Navigation Labels for All 7 Verticals ──
    'Properties & Estates': 'Immeubles & Résidences',
    'Units & Lease Matrix': 'Lots & Contrats de Bail',
    'Rent Roll & Collections': 'Quittances & Encaissements',
    'Facilities & Maintenance': 'Maintenance Technique',
    'Tenants Directory': 'Répertoire des Locataires',
    'Rent Arrears & Debts': 'Arriérés de Loyers',
    'Portfolio Analytics': 'Analytique du Patrimoine',
    'Walk-In Queue & POS': 'File d\'Attente & Caisse',
    'Barber Chairs & Commissions': 'Fauteuils & Commissions',
    'Grooming & Cuts Menu': 'Carte des Coupes & Soins',
    'Pomades & Grooming Stock': 'Stock Cire & Soins Barbe',
    'VIP Grooming Clients': 'Clients VIP Salon',
    'Shift & Revenue Reports': 'Rapports de Caisse & Recettes',
    'Session Desk & Bookings': 'Réservations de Séances',
    'Sanctuary Suites & Rooms': 'Suites & Cabines de Soins',
    'Rituals & Treatment Menu': 'Carte des Rituels & Massages',
    'VIP Wellness Passes': 'Forfaits & Abonnements VIP',
    'Essential Oils & Retail Stock': 'Huiles Essentielles & Produits',
    'Guest Wellness Profiles': 'Fiches Bien-Être Clients',
    'Spa Revenue Reports': 'Rapports Financiers Spa',
    'Bespoke Orders & Production': 'Commandes Sur-Mesure & Atelier',
    'Client Body Measurements': 'Mensurations Anatomiques',
    'Fabric Rolls & Textiles': 'Rouleaux de Tissus & Étoffes',
    'Atelier Clientele': 'Clientèle de l\'Atelier',
    'Deposits & Balances Due': 'Acomptes & Soldes à Percevoir',
    'Atelier Financial Reports': 'Rapports Financiers Atelier',
    'Client Engagements & Matters': 'Missions & Dossiers Clients',
    'Billable Hours & Timesheets': 'Heures Facturables & Temps',
    'Corporate Retainers (MRR)': 'Conventions Retainers (MRR)',
    'Corporate Clients CRM': 'Entreprises Clientes (CRM)',
    'Unpaid Invoices & WIP': 'Honoraires à Encaisser (WIP)',
    'Practice Utilization Reports': 'Rapports de Rentabilité Cabinet',
    'Chair Bookings & Checkout': 'Rendez-Vous & Encaissement',
    'Stylist Stations & Chairs': 'Postes de Coiffage & Fauteuils',
    'Coiffure, Nails & Glam Menu': 'Carte Coiffure, Ongles & Beauté',
    'Color & Chemical Formulas': 'Formules Couleur & Chimie',
    'Beauty & Hair Care Retail': 'Produits Capillaires & Beauté',
    'Salon Clients Directory': 'Fichier Clientes Salon',
    'Commission & Sales Reports': 'Rapports Commissions & Ventes',
    'Vehicle Fleet & Availability': 'Parc Automobile & Disponibilité',
    'Rental Dispatch & Agreements': 'Contrats de Location & Départs',
    'Check-Out / Return Inspections': 'États des Lieux Départ/Retour',
    'Hirers & Corporate Accounts': 'Locataires & Comptes Entreprises',
    'Security Deposits & Claims': 'Cautions & Dossiers Sinistres',
    'Fleet Revenue Analytics': 'Analytique Revenus de Flotte',

    // ── 1. Real Estate & Property Management ──
    'REAL ESTATE & PROPERTY PORTFOLIO PMS': 'PMS IMMOBILIER & GESTION DE PATRIMOINE LOCATIF',
    'Real Estate & Property Management': 'Immobilier & Gestion Locative',
    'Multi-property occupancy tracking, tenant leases, automated rent ledgers & facility maintenance':
      'Suivi d\'occupation multi-immeubles, baux locatifs, quittancement des loyers et maintenance technique',
    'Add Property': 'Ajouter un Immeuble',
    '+ Record Rent Payment': '+ Encaisser un Loyer',
    'Record Rent Payment': 'Encaisser un Loyer',
    'Managed Properties': 'Immeubles Gérés',
    'total leasable units': 'unités locatives au total',
    'Portfolio Occupancy': 'Taux d\'Occupation',
    'occupied': 'occupés',
    'vacant': 'vacants',
    'Collected Rent Revenue': 'Loyers Encaissés',
    'Expected Roll': 'Loyer Mensuel Attendu',
    'Open Maintenance': 'Maintenances Ouvertes',
    'Active tenant & facility work orders': 'Bons d\'intervention locataires en cours',
    'Portfolio Overview': 'Vue du Patrimoine',
    'Properties': 'Immeubles & Biens',
    'Units & Leases': 'Unités & Baux',
    'Rent Payments': 'Quittances & Loyers',
    'Maintenance Tickets': 'Tickets Maintenance',
    'Property Portfolio & Occupancy Status': 'Portefeuille Immobilier & État d\'Occupation',
    'Real-time building valuation, unit occupancy ratio, and property managers':
      'Valorisation des immeubles, taux d\'occupation des lots et gestionnaires assignés',
    'Units Leased': 'Lots Loués',
    'Leasable Units & Active Tenant Contracts': 'Unités Locatives & Baux Locataires Actifs',
    'Track unit occupancy, tenant contacts, lease expiration dates, and monthly rent roll':
      'Suivez l\'occupation des lots, les coordonnées des locataires, les échéances de bail et les loyers',
    'Add Unit / Lease': 'Ajouter Lot / Bail',
    'Search units, tenants, or properties...': 'Rechercher un lot, locataire ou immeuble...',
    'Search properties, units, tenants or receipts...': 'Rechercher immeubles, lots, locataires ou quittances...',
    'Unit #': 'Lot n°',
    'Property': 'Immeuble',
    'Type / Spec': 'Type / Surface',
    'Monthly Rent': 'Loyer Mensuel',
    'Current Tenant': 'Locataire Actuel',
    'Available for Lease': 'Disponible à la Location',
    'Lease Period': 'Période du Bail',
    'Ongoing': 'En cours',
    'Tenant Rent Collection Ledger': 'Journal d\'Encaissement des Loyers',
    'Verified rent receipts across Bank Transfer, Mobile Money, and Cash':
      'Quittances de loyer vérifiées par Virement Bancaire, Mobile Money et Espèces',
    'Receipt Ref': 'Réf. Quittance',
    'Unit': 'Lot',
    'Tenant Name': 'Nom du Locataire',
    'Period Covered': 'Période Couverte',
    'Amount Paid': 'Montant Payé',
    'Method': 'Mode',
    'Facility Maintenance & Work Orders': 'Maintenance Technique & Bons de Travaux',
    'Dispatch technicians and track repair costs across properties':
      'Affectez les techniciens et suivez les coûts de réparation par immeuble',
    'Log Maintenance Ticket': 'Créer un Ticket Maintenance',
    'Issue Summary': 'Nature de l\'Incident',
    'Category': 'Catégorie',
    'Priority': 'Priorité',
    'Est. Cost': 'Coût Estimé',
    'Assigned To': 'Technicien Assigné',
    'Mark Resolved': 'Marquer Résolu',
    'Resolved': 'Résolu',
    'Add Property to Portfolio': 'Ajouter un Immeuble au Patrimoine',
    'Save Property': 'Enregistrer l\'Immeuble',
    'Property Name': 'Nom de l\'Immeuble',
    'Property Type': 'Catégorie de Bien',
    'Address / Location': 'Adresse / Quartier',
    'Total Units': 'Nombre Total de Lots',
    'Target Monthly Rent Roll (RWF)': 'Revenu Locatif Mensuel Cible (RWF)',
    'Register Unit & Tenant Lease': 'Enregistrer un Lot & Contrat de Bail',
    'Save Unit': 'Enregistrer le Lot',
    'Unit Number / Code': 'Numéro / Code du Lot',
    'Unit Specification': 'Type de Lot',
    'Monthly Rent (RWF)': 'Loyer Mensuel (RWF)',
    'Occupancy Status': 'Statut d\'Occupation',
    'Tenant Full Name': 'Nom Complet du Locataire',
    'Tenant Phone': 'Téléphone du Locataire',
    'Record Tenant Rent Payment': 'Enregistrer un Paiement de Loyer',
    'Confirm Receipt': 'Valider la Quittance',
    'Amount Paid (RWF)': 'Montant Encaissé (RWF)',
    'Payment Method': 'Mode de Paiement',
    'Log Facility Maintenance Ticket': 'Ouvrir un Ticket de Maintenance',
    'Submit Ticket': 'Soumettre le Ticket',
    'Issue Description': 'Description de la Panne / Travaux',
    'Estimated Repair Cost (RWF)': 'Coût de Réparation Estimé (RWF)',

    // ── 2. Barbershop & Men's Grooming ──
    'EXECUTIVE BARBERSHOP & GROOMING LOUNGE': 'SALON DE COIFFURE HOMME & BARBIER EXÉCUTIF',
    'Barbershop & Grooming Lounge': 'Salon Barbier & Grooming',
    'Live barber chair stations, walk-in queue dispatch, grooming menu & barber commission splits':
      'Fauteuils de barbier en direct, file d\'attente sans RDV, carte des coupes et commissions barbiers',
    'Add Grooming Service': 'Ajouter un Service Coupe',
    '+ Check-In Walk-In Client': '+ Enregistrer Client Sans RDV',
    'Check-In Client': 'Enregistrer Client',
    'Active Barber Chairs': 'Fauteuils Barbiers Actifs',
    'Chairs currently in session': 'Fauteuils actuellement occupés',
    'Walk-In Queue': 'File d\'Attente',
    'Waiting': 'En attente',
    'currently in chair': 'actuellement au fauteuil',
    'Grooming Revenue': 'Recettes Coiffure & Barbe',
    'Tips collected': 'Pourboires reçus',
    'Completed Cuts': 'Coupes Terminées',
    'Verified grooming checkouts': 'Prestations encaissées aujourd\'hui',
    'Lounge Floor & Queue': 'Salle & File d\'Attente',
    'Grooming Menu': 'Carte des Coupes & Soins',
    'Barber Chair Stations & Master Barbers': 'Postes Barbiers & Maîtres Barbiers',
    'Live station status, assigned barber specialty, and commission rate':
      'Statut du fauteuil en direct, spécialité du barbier et taux de commission',
    'Add Barber Chair': 'Ajouter un Fauteuil',
    'Current Client': 'Client Actuel',
    'Ready for Next Walk-In': 'Prêt pour le prochain client',
    'Barber Split': 'Part Barbier',
    'Commission': 'Commission',
    'Live Walk-In & Appointment Queue': 'File d\'Attente Sans RDV & Passages en Direct',
    'Seat waiting clients into chairs and process instant MoMo/Cash checkouts':
      'Installez les clients au fauteuil et encaissez par Mobile Money ou Espèces',
    'Search client, barber, or ticket...': 'Rechercher un client, barbier ou ticket...',
    'Search clients, barbers, chairs or services...': 'Rechercher clients, barbiers, fauteuils ou coupes...',
    'Ticket': 'Ticket',
    'Client Name': 'Nom du Client',
    'Service': 'Prestation',
    'Barber & Chair': 'Barbier & Fauteuil',
    'Price': 'Tarif',
    'Tip': 'Pourboire',
    'Seat in Chair': 'Installer au Fauteuil',
    'Complete & Pay': 'Terminer & Encaisser',
    'Grooming & Styling Menu': 'Catalogue des Coupes, Dégradés & Soins Barbe',
    'Standard durations and pricing for haircuts, fades, beard sculpting & facials':
      'Durées standards et tarifs des coupes, dégradés à blanc, taille de barbe et soins visage',
    'Service Name': 'Nom de la Prestation',
    'Duration': 'Durée',
    'Check-In Walk-In Grooming Client': 'Enregistrer un Client en File d\'Attente',
    'Phone Number': 'Numéro de Téléphone',
    'Grooming Service': 'Prestation Choisie',
    'Preferred Barber': 'Barbier Souhaité',
    'Chair Station': 'Fauteuil Assigné',
    'Add Barber Chair Station': 'Ajouter un Poste Fauteuil Barbier',
    'Save Chair': 'Enregistrer le Fauteuil',
    'Chair Code': 'Code Fauteuil',
    'Assigned Master Barber': 'Maître Barbier Assigné',
    'Specialty': 'Spécialité',
    'Commission Split (%)': 'Taux de Commission (%)',
    'Add Grooming Menu Service': 'Ajouter une Prestation au Catalogue Barbier',
    'Save Service': 'Enregistrer la Prestation',
    'Duration (Minutes)': 'Durée (Minutes)',
    'Price (RWF)': 'Tarif (RWF)',

    // ── 3. Spa, Massage & Wellness Sanctuary ──
    'HOLISTIC SPA, MASSAGE & WELLNESS SANCTUARY': 'SANCTUAIRE SPA, MASSAGE & BIEN-ÊTRE HOLISTIQUE',
    'Spa & Wellness Sanctuary': 'Sanctuaire Spa & Bien-Être',
    'Treatment suite allocation, therapist scheduling, hydrotherapy rituals & VIP wellness memberships':
      'Allocation des suites de soins, planning des thérapeutes, rituels d\'hydrothérapie et abonnements VIP',
    'Enroll VIP Member': 'Inscrire Membre VIP',
    '+ Book Therapy Session': '+ Réserver une Séance Spa',
    'Book Therapy Session': 'Réserver une Séance Spa',
    'Sanctuary Suites Active': 'Suites de Soins Actives',
    'Private suites & hydrotherapy rooms': 'Cabines privées & salles d\'hydrothérapie',
    'Active / Upcoming Sessions': 'Séances Actives / à Venir',
    'rituals completed today': 'rituels terminés aujourd\'hui',
    'Session Revenue': 'Chiffre d\'Affaires Soins',
    'Verified therapy & ritual checkouts': 'Séances et rituels encaissés',
    'VIP Wellness Members': 'Membres VIP Bien-Être',
    'Float Value': 'Solde Forfaits',
    'Sanctuary Overview': 'Aperçu du Sanctuaire',
    'Therapy Bookings': 'Réservations de Soins',
    'Suites & Saunas': 'Cabines & Hammam',
    'Treatment Menu': 'Carte des Rituels',
    'VIP Memberships': 'Abonnements VIP',
    'Sanctuary Treatment Suites & Hydrotherapy Rooms': 'Cabines de Soins, Suites & Salles d\'Hydrothérapie',
    'Live ambient status, assigned holistic therapist, and guest occupancy':
      'Disponibilité des cabines en direct, thérapeute assigné et client en séance',
    'Lead Therapist': 'Thérapeute Principal',
    'Guest': 'Client(e)',
    'Sanitized & Ready for Guest': 'Aseptisée & Prête pour le prochain soin',
    'Therapy Bookings & Guest Ritual Schedule': 'Planning des Réservations & Rituels Bien-Être',
    'Manage guest check-ins, aromatherapy preferences, and session completion':
      'Gérez l\'accueil des hôtes, les préférences d\'aromathérapie et la clôture des soins',
    'Search guest, ritual, or therapist...': 'Rechercher un client, soin ou thérapeute...',
    'Search guests, suites, therapists or rituals...': 'Rechercher hôtes, cabines, thérapeutes ou soins...',
    'Booking Ref': 'Réf. Réservation',
    'Guest Name': 'Nom de l\'Hôte',
    'Treatment / Ritual': 'Soin / Rituel',
    'Suite & Therapist': 'Cabine & Thérapeute',
    'Time': 'Heure',
    'Amount': 'Montant',
    'Start Ritual': 'Démarrer le Soin',
    'Complete': 'Clôturer',
    'Holistic Spa & Wellness Ritual Menu': 'Carte des Soins Holistiques, Massages & Hammam',
    'Signature massages, organic botanical facials, and Moroccan hammam packages':
      'Massages signatures, soins visage botaniques bio et rituels de hammam marocain',
    'Add Treatment': 'Ajouter un Soin',
    'Treatment Name': 'Nom du Soin / Rituel',
    'Essential Oils / Products': 'Huiles Essentielles / Produits',
    'VIP Wellness Memberships & Prepaid Packages': 'Abonnements VIP Bien-Être & Forfaits Prépayés',
    'Track prepaid session balances and recurring wellness retainers':
      'Suivez le solde des séances prépayées et les cartes d\'abonnement annuel',
    'Member Name': 'Nom du Membre',
    'Tier / Package': 'Formule / Forfait',
    'Remaining Sessions': 'Séances Restantes',
    'sessions': 'séances',
    'Package Value': 'Valeur du Forfait',
    'Valid Until': 'Valide Jusqu\'au',
    'Book Holistic Spa Therapy Session': 'Réserver une Séance de Soin au Spa',
    'Confirm Booking': 'Confirmer la Réservation',
    'Guest Full Name': 'Nom Complet de l\'Hôte',
    'Guest Phone': 'Téléphone de l\'Hôte',
    'Select Ritual / Treatment': 'Choisir le Soin / Rituel',
    'Treatment Suite': 'Cabine de Soin',
    'Assigned Therapist': 'Thérapeute Assigné(e)',
    'Scheduled Time': 'Heure Prévue',
    'Add Holistic Spa Treatment': 'Ajouter un Rituel à la Carte du Spa',
    'Save Treatment': 'Enregistrer le Soin',
    'Products / Oils Used': 'Produits / Huiles Utilisés',
    'Enroll VIP Wellness Member': 'Inscrire un Membre VIP Bien-Être',
    'Enroll Member': 'Valider l\'Adhésion',
    'Membership Tier': 'Niveau d\'Abonnement',
    'Total Sessions Included': 'Nombre de Séances Incluses',
    'Package Price (RWF)': 'Prix du Forfait (RWF)',

    // ── 4. Bespoke Tailoring & Custom Clothing ──
    'BESPOKE TAILORING, HAUTE COUTURE & ATELIER ERP': 'ERP ATELIER SUR-MESURE, HAUTE COUTURE & CONFECTION',
    'Bespoke Tailoring & Atelier': 'Atelier de Couture Sur-Mesure',
    'Anatomical measurement profiles, multi-stage garment production, fitting calendar & luxury fabric rolls':
      'Fiches de mensurations anatomiques, suivi de confection multi-étapes, calendrier d\'essayages et rouleaux de tissus',
    'Record Measurements': 'Prendre les Mesures',
    '+ New Bespoke Order': '+ Nouvelle Commande Sur-Mesure',
    'New Bespoke Order': 'Nouvelle Commande Sur-Mesure',
    'Active Garments in Atelier': 'Tenues en Confection',
    'ready for client pickup': 'prêtes pour retrait client',
    'Collected Deposits': 'Acomptes Encaissés',
    'Total Order Book': 'Carnet de Commandes Total',
    'Balance Due on Delivery': 'Solde à Encaisser Livraison',
    'client body profiles': 'profils de mensurations enregistrés',
    'Textile Roll Valuation': 'Valeur Stock Tissus & Étoffes',
    'Luxury wool, linen & kitenge stock': 'Stock laine mérinos, lin, soie et wax',
    'Atelier Overview': 'Vue de l\'Atelier',
    'Bespoke Orders & Fittings': 'Commandes & Essayages',
    'Client Measurements': 'Mensurations Clients',
    'Fabric & Textile Rolls': 'Rouleaux de Tissus',
    'Bespoke Garment Production Pipeline': 'Pipeline de Confection Sur-Mesure & Essayages',
    'Track garments from pattern cutting and basted fitting to final delivery':
      'Suivez chaque tenue depuis la coupe du patron et le premier essayage jusqu\'à la livraison finale',
    'Search order, client, garment, or tailor...': 'Rechercher une commande, client, tenue ou tailleur...',
    'Search orders, clients, fabrics or measurements...': 'Rechercher commandes, clients, tissus ou mesures...',
    'Order #': 'Commande n°',
    'Garment & Fabric': 'Vêtement & Tissu',
    'Master Tailor': 'Maître Tailleur',
    'Fitting / Due': 'Essayage / Livraison',
    'Financials': 'Finances',
    'Deposit': 'Acompte',
    'Stage': 'Étape Atelier',
    'Advance Stage': 'Avancer l\'Étape',
    'Send to Sewing': 'Passer en Montage',
    'Book 1st Fitting': '1er Essayage',
    'Mark Ready': 'Marquer Prêt',
    'Deliver & Settle': 'Livrer & Solder',
    'Client Anatomical Measurement Profiles (cm)': 'Fiches de Mensurations Anatomiques Clients (cm)',
    'Permanent bespoke body dimensions and posture notes for repeat commissions':
      'Mesures corporelles permanentes et notes de morphologie pour les commandes récurrentes',
    'Record Client Measurements': 'Enregistrer des Mensurations',
    'Profile': 'Profil',
    'Neck / Chest': 'Cou / Poitrine',
    'Waist / Hips': 'Taille / Hanches',
    'Shoulder / Sleeve': 'Épaule / Manche',
    'Inseam / Jacket': 'Entrejambe / Veste',
    'Posture & Fit Notes': 'Morphologie & Coupe',
    'Luxury Fabric & Textile Roll Inventory': 'Inventaire des Rouleaux de Tissus & Étoffes de Luxe',
    'Track yardage/meters remaining across Italian wool, linen, velvet, and silk rolls':
      'Suivez le métrage disponible des rouleaux de laine italienne, lin, velours et soie',
    'Add Fabric Roll': 'Ajouter un Rouleau de Tissu',
    'SKU Code': 'Code Réf.',
    'Fabric Name': 'Désignation du Tissu',
    'Material & Pattern': 'Matière & Motif',
    'Meters in Stock': 'Métrage en Stock',
    'Price / Meter': 'Prix / Mètre',
    'Commission New Bespoke Garment Order': 'Créer une Nouvelle Commande Sur-Mesure',
    'Create Bespoke Order': 'Créer la Commande',
    'Garment Commission': 'Type de Tenue / Vêtement',
    'Selected Fabric': 'Tissu Sélectionné',
    'Total Price (RWF)': 'Prix Total (RWF)',
    'Advance Deposit Paid (RWF)': 'Acompte Versé (RWF)',
    'Target Delivery Date': 'Date de Livraison Prévue',
    'Record Client Anatomical Measurements (cm)': 'Enregistrer les Mensurations d\'un Client (cm)',
    'Save Measurements': 'Enregistrer les Mesures',
    'Client Full Name': 'Nom Complet du Client',
    'Profile Label': 'Libellé du Profil',
    'Neck (cm)': 'Tour de Cou (cm)',
    'Chest (cm)': 'Poitrine (cm)',
    'Waist (cm)': 'Tour de Taille (cm)',
    'Shoulder (cm)': 'Carrure Épaules (cm)',
    'Sleeve (cm)': 'Longueur Manche (cm)',
    'Inseam (cm)': 'Entrejambe (cm)',
    'Posture & Styling Notes': 'Notes de Posture & Préférences de Coupe',
    'Add Luxury Fabric Roll': 'Ajouter un Rouleau de Tissu au Stock',
    'Save Fabric Roll': 'Enregistrer le Rouleau',
    'Material Type': 'Type de Matière',
    'Color / Weave Pattern': 'Couleur / Motif',

    // ── 5. Professional Services & Consulting ──
    'PROFESSIONAL SERVICES, LEGAL & ADVISORY ERP': 'ERP CABINET DE CONSEIL, AUDIT & SERVICES PROFESSIONNELS',
    'Professional Services & Advisory': 'Cabinet de Conseil & Services Professionnels',
    'Client engagement milestones, billable timesheet utilization, corporate retainers & practice billing':
      'Suivi des missions clients, feuilles de temps facturables, provisions mensuelles (retainers) et facturation d\'honoraires',
    'New Engagement': 'Nouvelle Mission',
    '+ Log Billable Hours': '+ Saisir Heures Facturables',
    'Log Billable Hours': 'Saisir Heures Facturables',
    'Active Engagements': 'Missions Actives',
    'Contracted': 'Budget sous contrat',
    'Total Billed Revenue': 'Honoraires Facturés',
    'Milestone & hourly realization': 'Facturation au forfait et au temps passé',
    'Billable Utilization': 'Heures Facturables',
    'WIP Value': 'En-cours facturable (WIP)',
    'Monthly Retainer MRR': 'Revenu Mensuel Récurrent (Retainers)',
    'active corporate retainers': 'contrats d\'abonnement actifs',
    'Practice Overview': 'Vue du Cabinet',
    'Client Engagements': 'Missions & Mandats',
    'Billable Timesheets': 'Feuilles de Temps',
    'Corporate Retainers': 'Conventions d\'Abonnement',
    'Client Engagements & Milestone Realization': 'Missions Clients & Avancement de la Facturation',
    'Track budget burn rate, lead partners, and billed project milestones':
      'Suivez la consommation des budgets, les associés responsables et les jalons facturés',
    'New Client Engagement': 'Nouvelle Mission Client',
    'Search client, engagement, or consultant...': 'Rechercher un client, mission ou consultant...',
    'Search clients, projects, consultants or retainers...': 'Rechercher clients, missions, consultants ou contrats...',
    'Code': 'Code',
    'Client Organization': 'Entreprise Cliente',
    'Engagement Scope': 'Objet de la Mission',
    'Lead Consultant': 'Associé / Consultant Référent',
    'Contract Budget': 'Budget Contractuel',
    'Realization / Billed': 'Avancement / Facturé',
    'billed': 'facturés',
    'Due Date': 'Échéance',
    'Consultant Billable Timesheets & WIP Ledger': 'Journal des Feuilles de Temps & Heures Facturables',
    'Approve consultant hours and convert work-in-progress into client invoices':
      'Validez les heures des consultants et convertissez les travaux en cours (WIP) en factures clients',
    'Date': 'Date',
    'Consultant': 'Consultant',
    'Client': 'Client',
    'Deliverable / Task': 'Livrable / Activité Réalisée',
    'Hours × Rate': 'Heures × Taux Horaire',
    'Total Billable': 'Total Facturable',
    'Mark Invoiced': 'Marquer Facturé',
    'Billed': 'Facturé',
    'Corporate Advisory Retainers': 'Conventions d\'Honoraires Récurrents (Retainers)',
    'Recurring monthly legal, tax, and strategic advisory SLAs':
      'Contrats d\'accompagnement mensuel juridique, fiscal, comptable et stratégique',
    'Add Corporate Retainer': 'Ajouter un Contrat Retainer',
    'Retainer Scope': 'Périmètre de la Convention',
    'Monthly Fee': 'Forfait Mensuel',
    'Hour Allocation': 'Quota d\'Heures',
    'hrs used': 'h consommées',
    'Next Renewal': 'Prochain Renouvellement',
    'Register New Client Advisory Engagement': 'Enregistrer une Nouvelle Mission Client',
    'Create Engagement': 'Créer la Mission',
    'Engagement Title': 'Intitulé de la Mission',
    'Lead Partner / Consultant': 'Associé / Consultant Responsable',
    'Contracted Budget (RWF)': 'Budget Contractuel (RWF)',
    'Target Completion Date': 'Date de Clôture Prévue',
    'Log Consultant Billable Hours': 'Saisir des Heures Facturables Consultant',
    'Log Hours': 'Enregistrer les Heures',
    'Consultant Name': 'Nom du Consultant',
    'Deliverable / Activity Description': 'Description du Livrable / Prestation',
    'Billable Hours': 'Heures Facturables',
    'Hourly Rate (RWF)': 'Taux Horaire (RWF)',
    'Add Corporate Advisory Retainer': 'Ajouter une Convention d\'Abonnement Client',
    'Save Retainer': 'Enregistrer la Convention',
    'Monthly Retainer Fee (RWF)': 'Honoraires Mensuels (RWF)',
    'Included Monthly Hours': 'Heures Mensuelles Incluses',

    // ── 6. Hair Salon & Beauty Studio ──
    'HAIR SALON, COLOR BAR & BEAUTY STUDIO ERP': 'ERP SALON DE COIFFURE, BAR À COULEUR & INSTITUT DE BEAUTÉ',
    'Hair Salon & Beauty Studio': 'Salon de Coiffure & Institut de Beauté',
    'Stylist station floor, balayage & color formula cards, braiding appointments & beauty POS':
      'Postes de coiffage, fiches techniques de coloration & balayage, rendez-vous tresses et encaissement beauté',
    'Save Color Formula': 'Enregistrer Formule Couleur',
    '+ Book Salon Appointment': '+ Réserver un Rendez-Vous',
    'Book Salon Appointment': 'Réserver un Rendez-Vous',
    'Styling Stations Active': 'Postes de Coiffage Actifs',
    'Hair, color bar & nail artistry bays': 'Postes coiffure, coloration et onglerie',
    'Active Appointments': 'Rendez-Vous Actifs',
    'clients styled today': 'clientes coiffées aujourd\'hui',
    'Studio Revenue': 'Chiffre d\'Affaires Salon',
    'Completed hair & beauty checkouts': 'Prestations coiffure & beauté encaissées',
    'Client Color Formulas': 'Formules Couleur Clientes',
    'Tracked dye ratios & curl porosity cards': 'Dosages pigments, oxydants et porosité capillaire',
    'Studio Overview': 'Aperçu du Salon',
    'Appointments': 'Rendez-Vous',
    'Stylist Stations': 'Postes de Coiffage',
    'Service Menu': 'Carte des Prestations',
    'Color & Hair Formulas': 'Fiches Couleur & Chimie',
    'Stylist Stations, Color Bar & Bridal Suite': 'Postes de Coiffage, Bar à Couleur & Suite Mariée',
    'Live station occupancy, lead stylist specialty, and commission rate':
      'Occupation des postes en direct, spécialité de la coiffeuse et commission',
    'Station Sanitized & Ready': 'Poste désinfecté & prêt',
    'Salon Styling & Beauty Appointments': 'Rendez-Vous Coiffure, Tresses & Soins Beauté',
    'Seat clients at styling stations and complete checkouts':
      'Installez les clientes aux postes de coiffage et validez les encaissements',
    'Search client, service, or stylist...': 'Rechercher une cliente, prestation ou coiffeuse...',
    'Search clients, stylists, formulas or services...': 'Rechercher clientes, coiffeuses, formules ou soins...',
    'Stylist & Station': 'Coiffeuse & Poste',
    'Seat Client': 'Installer au Poste',
    'Client Hair Color & Chemical Formula Vault': 'Répertoire des Formules de Coloration & Soins Chimiques',
    'Exact color mix ratios, developer volume, curl porosity, and processing timers':
      'Dosages exacts des tubes, volume d\'oxydant, porosité capillaire et temps de pose',
    'Save Client Formula': 'Nouvelle Fiche Couleur',
    'Hair Texture / Porosity': 'Texture / Porosité',
    'Color Formula & Mix Ratio': 'Formule Couleur & Dosage',
    'Developer': 'Oxydant / Révélateur',
    'Timer': 'Temps de Pose',
    'Colorist': 'Coloriste',
    'Aftercare Notes': 'Notes & Entretien',
    'Hair Salon & Beauty Service Catalog': 'Catalogue des Prestations Coiffure & Beauté',
    'Coloring, silk press, protective braids, bridal glam & gel manicures':
      'Coloration, lissage au fer (silk press), tresses protectrices, coiffure mariée et manucure gel',
    'Add Salon Service': 'Ajouter une Prestation',
    'Book Salon Styling Appointment': 'Prendre un Rendez-Vous au Salon',
    'Book Appointment': 'Confirmer le Rendez-Vous',
    'Select Service': 'Choisir la Prestation',
    'Assigned Stylist': 'Coiffeuse / Styliste Assignée',
    'Styling Station': 'Poste de Coiffage',
    'Lead Stylist': 'Coiffeuse / Styliste',
    'Station Code': 'Poste de Coiffage',
    'Save Client Hair Color & Chemical Formula': 'Enregistrer une Fiche Technique Coloration Cliente',
    'Save Formula Card': 'Enregistrer la Fiche Couleur',
    'Save Formula': 'Enregistrer la Formule',
    'Hair Texture & Porosity': 'Texture & Porosité Capillaire',
    'Exact Color Mix Formula': 'Formule Exacte de Coloration',
    'Developer Volume': 'Volume d\'Oxydant',
    'Processing Time (Minutes)': 'Temps de Pose (Minutes)',
    'Processing Time (Mins)': 'Temps de Pose (Minutes)',
    'Stylist & Aftercare Notes': 'Notes Coiffeuse & Soin Post-Coloration',
    'Aftercare & Allergy Notes': 'Notes d\'Entretien & Test d\'Allergie',
    'Add Hair Salon & Beauty Service': 'Ajouter une Prestation au Catalogue du Salon',
    'Add Salon & Beauty Service': 'Ajouter une Prestation au Catalogue du Salon',
    'Service Price (RWF)': 'Tarif de la Prestation (RWF)',

    // ── 7. Car Rental & Fleet Operations ──
    'CAR RENTAL, EXECUTIVE CHAUFFEUR & FLEET TELEMETRY': 'LOCATION DE VÉHICULES, CHAUFFEUR EXÉCUTIF & GESTION DE FLOTTE',
    'Car Rental & Fleet Operations': 'Location de Véhicules & Gestion de Flotte',
    'Fleet availability, rental dispatch contracts, odometer & fuel check-in logs, and security deposits':
      'Disponibilité de la flotte, contrats de location, relevés kilométriques & carburant, et cautions clients',
    'Log Vehicle Inspection': 'État des Lieux Véhicule',
    '+ Dispatch Rental Contract': '+ Nouveau Contrat de Location',
    'Dispatch Rental Contract': 'Nouveau Contrat de Location',
    'Fleet Utilization': 'Taux d\'Utilisation Flotte',
    'rented': 'en location',
    'available': 'disponibles',
    'Active Rental Contracts': 'Contrats de Location Actifs',
    'total vehicles in fleet': 'véhicules dans la flotte',
    'Rental Contract Revenue': 'Chiffre d\'Affaires Location',
    'Deposits Held': 'Cautions Détenues',
    'Service / Maintenance': 'Entretien / Garage',
    'Vehicles': 'Véhicules',
    'Scheduled oil & brake inspections': 'Révisions vidange, freins et pneumatiques',
    'Fleet Command Center': 'Centre de Pilotage Flotte',
    'Vehicle Fleet': 'Parc Automobile',
    'Rental Agreements': 'Contrats de Location',
    'Check-In / Out Inspections': 'États des Lieux Départ/Retour',
    'Executive Vehicle Fleet & Telemetry': 'Parc Automobile & Télémétrie des Véhicules',
    'Live plate registry, odometer mileage, fuel level, and daily rental tariffs':
      'Immatriculations, kilométrage compteur, niveau de carburant et tarifs journaliers',
    'Add Fleet Vehicle': 'Ajouter un Véhicule',
    'Fuel': 'Carburant',
    'Odometer': 'Kilométrage',
    'day': 'jour',
    'Active Vehicle Rental & Chauffeur Agreements': 'Contrats de Location & Mise à Disposition avec Chauffeur',
    'Track dispatched vehicles, driver licenses, security deposits, and return settlements':
      'Suivez les véhicules sortis, permis de conduire, dépôts de garantie et retours de location',
    'Search contract, renter, vehicle, or plate...': 'Rechercher un contrat, locataire, véhicule ou plaque...',
    'Search plates, models, clients or contracts...': 'Rechercher plaques, modèles, locataires ou contrats...',
    'Contract #': 'Contrat n°',
    'Client / Organization': 'Locataire / Organisation',
    'Vehicle & Plate': 'Véhicule & Plaque',
    'Rental Period': 'Période de Location',
    'Total Fee': 'Montant Total',
    'Deposit Held': 'Caution Versée',
    'Check-In Return': 'Enregistrer le Retour',
    'Returned': 'Restitué',
    'Pre-Rental & Return Vehicle Inspection Logs': 'Journal des États des Lieux Départ & Retour',
    'Verify odometer reading, fuel level, scratch/dent condition, and damage charges':
      'Vérifiez le kilométrage, le niveau de carburant, l\'état de la carrosserie et les frais de remise en état',
    'Plate #': 'Immatriculation',
    'Type': 'Type de Contrôle',
    'Fuel Level': 'Niveau Carburant',
    'Exterior & Tire Notes': 'État Carrosserie & Pneumatiques',
    'Inspector': 'Inspecteur',
    'Add Vehicle to Rental Fleet': 'Ajouter un Véhicule au Parc de Location',
    'Save Vehicle': 'Enregistrer le Véhicule',
    'Rwanda Plate Number': 'Numéro d\'Immatriculation (Plaque)',
    'Vehicle Make & Model': 'Marque & Modèle du Véhicule',
    'Fleet Class': 'Catégorie de Véhicule',
    'Daily Tariff (RWF)': 'Tarif Journalier (RWF)',
    'Current Odometer (km)': 'Kilométrage Actuel (km)',
    'Dispatch New Vehicle Rental Contract': 'Créer un Nouveau Contrat de Location de Véhicule',
    'Dispatch Vehicle': 'Valider la Sortie du Véhicule',
    'Renter / Organization Name': 'Nom du Locataire / Organisation',
    'Driver License / Passport': 'Permis de Conduire / Passeport',
    'Select Fleet Plate': 'Sélectionner la Plaque du Véhicule',
    'Vehicle Model': 'Modèle du Véhicule',
    'Rental Days': 'Jours de Location',
    'Daily Rate (RWF)': 'Tarif Journalier (RWF)',
    'Deposit (RWF)': 'Caution (RWF)',
    'Select Available Vehicle': 'Sélectionner un Véhicule',
    'Pickup Date': 'Date de Départ',
    'Return Date': 'Date de Retour',
    'Total Rental Days': 'Nombre de Jours',
    'Security Deposit (RWF)': 'Dépôt de Garantie / Caution (RWF)',
    'Total Rental Fee (RWF)': 'Montant Total de la Location (RWF)',
    'Log Pre/Post-Rental Vehicle Inspection': 'Enregistrer une Fiche d\'État des Lieux Véhicule',
    'Log Vehicle Inspection Checklist': 'Enregistrer une Fiche d\'État des Lieux Véhicule',
    'Save Inspection': 'Enregistrer l\'État des Lieux',
    'Vehicle Plate Number': 'Immatriculation du Véhicule',
    'Inspection Stage': 'Type d\'État des Lieux',
    'Odometer Reading (km)': 'Kilométrage Relevé (km)',
    'Fuel Tank Level': 'Niveau du Réservoir',
    'Body, Tires & Glass Condition': 'État Carrosserie, Pneumatiques & Vitrage',
    'Bodywork, Tires & Interior Condition': 'Observations Carrosserie, Pneus & Intérieur',

    // ── 8. All 31 Domain Roles & 29 Feature Permissions (Settings -> Roles & Permissions) ──
    'Managing Broker': 'Courtier Directeur (Managing Broker)',
    'Property Manager': 'Gestionnaire Immobilier',
    'Real Estate Agent': 'Agent Immobilier',
    'Leasing Coordinator': 'Coordinateur des Baux Locatifs',
    'Maintenance Supervisor': 'Superviseur Maintenance Immobilière',
    'Barbershop Manager': 'Gérant du Salon Barbier',
    'Master Barber': 'Maître Barbier',
    'Junior Barber': 'Barbier Coiffeur',
    'Front Desk / Receptionist': 'Réceptionniste / Accueil',
    'Spa Director': 'Directeur(rice) du Spa',
    'Massage Therapist': 'Massothérapeute / Praticien Spa',
    'Esthetician': 'Esthéticienne',
    'Wellness Consultant': 'Conseiller(ère) Bien-Être',
    'Spa Receptionist': 'Réceptionniste Spa',
    'Atelier Director': 'Directeur d\'Atelier Couture',
    'Seamstress / Patternmaker': 'Couturier(ère) / Modéliste',
    'Fitting Specialist': 'Spécialiste Essayages & Mesures',
    'Managing Partner': 'Associé Directeur (Managing Partner)',
    'Senior Consultant': 'Consultant Senior',
    'Project Manager': 'Chef de Mission / Projet',
    'Billing & Practice Coordinator': 'Responsable Facturation & Recouvrement',
    'Salon Manager': 'Gérant(e) du Salon de Coiffure',
    'Master Colorist': 'Maître Coloriste',
    'Hair Stylist': 'Coiffeur(se) Styliste',
    'Beauty & Makeup Artist': 'Maquilleuse & Esthéticienne',
    'Salon Receptionist': 'Réceptionniste Salon',
    'Fleet Manager': 'Gestionnaire de Flotte Automobile',
    'Rental Desk Agent': 'Agent de Comptoir Location',
    'Vehicle Inspection Specialist': 'Inspecteur État des Lieux Véhicules',
    'Fleet Maintenance Coordinator': 'Coordinateur Maintenance Flotte',

    // Feature Permission Titles
    'Real Estate Portfolio Dashboard': 'Tableau de Bord Patrimoine Immobilier',
    'Property Buildings & Estates': 'Immeubles & Résidences',
    'Units & Lease Agreements': 'Unités Locatives & Contrats de Bail',
    'Rent Ledger & Collections': 'Quittancement & Encaissement des Loyers',
    'Property Maintenance & Work Orders': 'Maintenance Immobilière & Bons de Travaux',
    'Barbershop Studio Dashboard': 'Tableau de Bord Salon Barbier',
    'Walk-In Queue & Grooming POS': 'File d\'Attente Sans RDV & Caisse Barbier',
    'Barber Chairs & Stations': 'Fauteuils de Barbier & Commissions',
    'Grooming & Cut Catalog': 'Catalogue des Coupes & Soins Barbe',
    'Spa Sanctuary Dashboard': 'Tableau de Bord Sanctuaire Spa',
    'Treatment Bookings & Sessions': 'Réservations de Soins & Séances Spa',
    'Therapy Suites & Rooms': 'Suites de Massage & Salles d\'Hydrothérapie',
    'Wellness Packages & Memberships': 'Forfaits Bien-Être & Abonnements VIP',
    'Bespoke Atelier Dashboard': 'Tableau de Bord Atelier Sur-Mesure',
    'Bespoke Orders & Fitting Pipeline': 'Commandes Sur-Mesure & Essayages',
    'Client Body Measurement Profiles': 'Fiches de Mensurations Clients',
    'Fabric Rolls & Atelier Stock': 'Rouleaux de Tissus & Stock Atelier',
    'Advisory Practice Dashboard': 'Tableau de Bord Cabinet de Conseil',
    'Client Engagements & Projects': 'Missions Clients & Mandats',
    'Billable Timesheets & WIP': 'Feuilles de Temps Facturables (WIP)',
    'Client Retainers & Trust Billing': 'Conventions d\'Honoraires Récurrents (Retainers)',
    'Hair Salon Studio Dashboard': 'Tableau de Bord Salon de Coiffure',
    'Salon Appointments & Checkout': 'Rendez-Vous Coiffure & Encaissement',
    'Client Color & Chemical Formulas': 'Formules de Coloration & Soins Chimiques',
    'Styling Chairs & Specialists': 'Postes de Coiffage & Spécialistes',
    'Fleet Operations Dashboard': 'Tableau de Bord Flotte Automobile',
    'Rental Agreements & Dispatch': 'Contrats de Location & Départs',
    'Vehicle Damage & Claims Log': 'États des Lieux & Sinistres Véhicules',
  },
};
